import {
  applyStorefrontProductUrl,
  clearStorefrontProductUrl,
} from '@domain/microproducts/boot-params';
import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';

/**
 * Keeps the browser URL in sync with the focused storefront microproduct:
 * `/storefront/:productId` on focus, back to `/` on blur — so the link is
 * shareable and refresh-safe.
 *
 * Both writes go through the boot-params helpers, which are replaceState-
 * only (never pushState: no history entries, so browser back keeps today's
 * behavior of leaving the site), preserve the existing history.state, and
 * are suppressed for the whole session by `urlWritesDisabled` when a
 * reserved boot param (punchout/smart-order) was present — those flows
 * read the LIVE URL long after boot and must never see it change.
 */
export const useStorefrontUrlMaintenance = (
  productId: string | undefined,
): void => {
  useFocusEffect(
    useCallback(() => {
      if (!productId) {
        return undefined;
      }

      applyStorefrontProductUrl(productId);
      return () => {
        clearStorefrontProductUrl();
      };
    }, [productId]),
  );
};
